import type { ReactNode } from 'react';

interface DashboardMetricCardsProps {
  metrics: Array<{
    icon: ReactNode;
    label: string;
    count: number | string;
  }>;
}

export default function DashboardMetricCards({ metrics }: DashboardMetricCardsProps) {
  return (
    <div className="mb-6 overflow-x-auto">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 min-w-0">
        {metrics.map((item, index) => (
          <div
            key={index}
            className="bg-gray-100 dark:bg-gray-800 min-w-[180px] p-4 rounded-lg shadow flex flex-col items-center text-center"
          >
            <div className="bg-orange-100 dark:bg-orange-200 p-2 rounded-full mb-2">
              {item.icon}
            </div>
            <p className="text-sm text-gray-500 dark:text-gray-300">{item.label}</p>
            <p className="text-xl font-semibold">{item.count}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
